import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { resourceServerUrl } from '../common/constants/server-settings';
import { getHttpHeaders } from '../common/constants/constants';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    //private accountInfoURI: string = `${resourceServerUrl}/v1/accounts`;
    private banksURI: string = `${resourceServerUrl}/v1/banks`;
    private branchURI:string=`${resourceServerUrl}/v1/branches`;

    constructor(private http: HttpClient) { }

    //getAccountInfo(accountNo: string): Observable<HttpResponse<any>> {

    //    return this.http.get(`${this.accountInfoURI}/${accountNo}/minimal-info`, {

    //        headers: getHttpHeaders(),

    //        observe: 'response'
    //    });
    //}
        getBranchInfo(branchCode: string): Observable<HttpResponse<any>> {

                return this.http.get(`${this.branchURI}/${branchCode}`, {

                headers: getHttpHeaders(),

                    observe: 'response'
            });
       }

    getAccounts(bankId: string = '010'): Observable<HttpResponse<any>> {

        return this.http.get(`${this.banksURI}/${bankId}/customer/accounts`, {
            headers: getHttpHeaders(),
            observe: 'response'
        }); 
    }

    getCreditAccounts(bankId: string = '010'): Observable<HttpResponse<any>> {

        return this.http.get(`${this.banksURI}/${bankId}/customer/accounts??canCredit=YES&canDebit=No`, {
            headers: getHttpHeaders(),
            observe: 'response'
        });
    }

    getDebitAccounts(bankId: string = '010'): Observable<HttpResponse<any>> {
        return this.http.get(`${this.banksURI}/${bankId}/customer/accounts??canCredit=NO&canDebit=YES`, {
            headers: getHttpHeaders(),
            observe: 'response'
        });
    }

    getAccountsForChequebookRequest(bankId: string = '010'): Observable<HttpResponse<any>> {
        return this.http.get(`${this.banksURI}/${bankId}/customer/accounts?canChequeRequest=YES`, {
            headers: getHttpHeaders(),
            observe: 'response'
        });
    }

    getAccountSummary(accountOid: string): Observable<HttpResponse<any>> {
        let url: string = `${this.banksURI}/010/accounts/${accountOid}/minimal-info`;
        return this.http.get(url, {
            headers: getHttpHeaders(),
            observe: 'response'
        });
        
    }

    // getAccountSummary(accountId: string, bankId: string = '010',
    //     offset: number = 0, limit: number = 15): Observable<HttpResponse<any>> {

    //     let accountSummaryURI: string = `${resourceServerUrl}/v1/banks/${bankId}/accounts/${accountId}/transactions?offset=${offset}&limit=${limit}`;

    //     return this.http.get(accountSummaryURI, { headers: getHttpHeaders(), observe: 'response' });
    // }
}
